import { watch } from 'vue';
import { useI18n } from './useI18n';
export function useAnalytics() {
    const { currentLocale } = useI18n();
    const ymId = process.env.VUE_APP_YM_ID;
    const gaId = process.env.VUE_APP_GA_ID;
    // Кэшируем результат определения региона
    let cachedIsRussian = null;
    // Функция определения России по IP
    const checkIfRussian = async () => {
        // Если уже определили в этой сессии - возвращаем
        if (cachedIsRussian !== null)
            return cachedIsRussian;
        try {
            // Таймаут 3 секунды, чтобы не ждать вечно
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 3000);
            // Получаем данные по IP
            const response = await fetch('https://ipwho.is/');
            clearTimeout(timeoutId);
            if (response.ok) {
                const data = await response.json();
                const isRussian = data.country_code === 'RU';
                console.log(`[Analytics] IP detected: ${data.country_code}, isRussian: ${isRussian}`);
                return isRussian;
            }
        }
        catch (error) {
            console.warn('[Analytics] IP detection failed, using language fallback');
        }
        // Fallback на язык браузера
        const acceptLang = navigator.language.toLowerCase();
        cachedIsRussian = acceptLang === 'ru' || acceptLang === 'ru-ru';
        console.log(`[Analytics] Using language fallback: isRussian=${cachedIsRussian}`);
        return cachedIsRussian;
    };
    // Загрузка Яндекс.Метрики
    const loadYandexMetrica = () => {
        if (!ymId) {
            console.warn('Yandex Metrica ID not found');
            return;
        }
        if (document.querySelector('script[src*="mc.yandex.ru/metrika"]')) {
            return;
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
      (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
      })(window, document,'script','https://mc.yandex.ru/metrika/tag.js','ym');
      
      ym(${ymId}, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: "dataLayer",
        referrer: document.referrer,
        url: location.href,
        accurateTrackBounce: true,
        trackLinks: true
      });
    `;
        document.head.appendChild(script);
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${ymId}" style="position:absolute; left:-9999px;" alt="" /></div>`;
        document.head.appendChild(noscript);
        console.log('[Analytics] Yandex Metrica loaded');
    };
    // Загрузка Google Analytics
    const loadGoogleAnalytics = () => {
        if (!gaId) {
            console.warn('Google Analytics ID not found');
            return;
        }
        const ymScript = document.querySelector('script[src*="mc.yandex.ru/metrika"]');
        if (ymScript)
            ymScript.remove();
        if (window.ym)
            delete window.ym;
        window.dataLayer = window.dataLayer || [];
        // Исправлено: используем стрелочную функцию вместо arguments
        window.gtag = (...args) => {
            window.dataLayer.push(args);
        };
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(script);
        window.gtag('js', new Date());
        window.gtag('config', gaId);
        console.log('[Analytics] Google Analytics loaded');
    };
    // Главная функция - вызывается при нажатии "Accept All"
    const initAnalyticsOnAccept = async () => {
        const isRussian = await checkIfRussian();
        if (isRussian) {
            loadYandexMetrica();
        }
        else {
            loadGoogleAnalytics();
        }
    };
    // Следим за сменой языка (опционально, если пользователь переключил язык вручную)
    watch(currentLocale, async (newLocale) => {
        const hasConsent = localStorage.getItem('cookieConsent') === 'all';
        if (!hasConsent)
            return;
        // При смене языка переопределяем аналитику
        if (newLocale === 'ru') {
            loadYandexMetrica();
        }
        else {
            loadGoogleAnalytics();
        }
    });
    return {
        loadYandexMetrica,
        loadGoogleAnalytics,
        initAnalyticsOnAccept,
        checkIfRussian
    };
}
